import { Flex, Text } from '@theme-ui/components';
import { Suspense, lazy, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { APP_BASE_URL } from '../../../config/client.config';
import CartButton from '../CartButton/CartButton';
import { NINavigationCommunity, NINavigationSupport } from '../webex-ni/icons';
import AccountWidget from './AccountWidget';
import messages from './Header.messages';
import styles from './Header.styles';

const StoreSwitch = lazy(
  () =>
    import(
      /*webpackChunkName: 'StoreSwitch' */ '@app/components/StoreSwitch/StoreSwitch'
    ),
);

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const { language } = useParams<{ language: string }>();
  const { formatMessage } = useIntl();
  return (
    <header css={styles.header}>
      <Flex css={styles.contentWrapper}>
        <a css={styles.logo} href={APP_BASE_URL}>
          <span>Native Instruments</span>
        </a>

        <nav css={styles.nav(isMenuOpen)}>
          <ul css={styles.navUl}>
            <li css={styles.navLi}>
              <a css={styles.navLink} href={`/${language}/catalog/software/`}>
                <FormattedMessage {...messages.software} />
              </a>
            </li>
            <li css={styles.navLi}>
              <a css={styles.navLink} href={`/${language}/catalog/hardware/`}>
                <FormattedMessage {...messages.hardware} />
              </a>
            </li>
            <li css={styles.navLi}>
              <a
                href={`/${language}/catalog/hardware/traktor/`}
                css={styles.navLink}
              >
                <FormattedMessage {...messages.dj} />
              </a>
            </li>
            <li css={styles.navLi}>
              <a
                href={`/${language}/catalog/software/bundles/`}
                css={styles.navLink}
              >
                <FormattedMessage {...messages.bundles} />
              </a>
            </li>
          </ul>
        </nav>

        <div css={styles.accountContainer}>
          <a href={`/${language}/community/`}>
            <NINavigationCommunity
              title={formatMessage(messages.community)}
              style={{ width: '32px', color: 'black' }}
            />
          </a>
          <a href={`http://support.native-instruments.com/hc/${language}/`}>
            <NINavigationSupport
              title={formatMessage(messages.support)}
              style={{ width: '32px', color: 'black' }}
            />
          </a>

          <Suspense fallback={null}>
            <AccountWidget />
          </Suspense>
          <CartButton />
          <Suspense fallback={null}>
            <StoreSwitch />
          </Suspense>

          <button
            css={styles.mobileMenu}
            onClick={() => setMenuOpen(!isMenuOpen)}
          >
            <Text sx={{ display: 'block' }} pr={2}>
              MENU
            </Text>
            <div css={styles.hamburger(isMenuOpen)}>
              <span />
              <span />
              <span />
            </div>
          </button>
        </div>
      </Flex>
    </header>
  );
};

export default Header;
